import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { rupiah, tgl, today, monthStart } from "../../lib/format";
import { Row, PdfButton, PeriodeFilter, dl } from "./shared";

export default function LabaRugiPanel() {
  const [lr, setLr] = useState(null);
  const [start, setStart] = useState(monthStart());
  const [end, setEnd] = useState(today());

  useEffect(() => {
    api.get("/reports/laba-rugi", { params: { start: monthStart(), end: today() } }).then((r) => setLr(r.data)).catch(() => {});
  }, []);

  const applyFilter = () => {
    api.get("/reports/laba-rugi", { params: { start: start || undefined, end: end || undefined } })
      .then((r) => setLr(r.data)).catch(() => {});
  };

  return (
    <>
      <div className="flex items-center justify-between mt-4 mb-2">
        <h2 className="text-base font-bold tracking-tight">Laba Rugi</h2>
        <PdfButton testid="laba-rugi-pdf-button" onClick={() => dl(`/reports/laba-rugi/pdf?start=${start}&end=${end}`, "laba-rugi.pdf")} />
      </div>
      <PeriodeFilter start={start} end={end} setStart={setStart} setEnd={setEnd} onApply={applyFilter} />
      {lr && (
        <div className="mt-4 rounded-md border border-border bg-white divide-y divide-border" data-testid="laba-rugi-report">
          <Row label="Pendapatan Penjualan" value={lr.pendapatan} testid="lr-pendapatan" />
          <Row label="Harga Pokok Penjualan (HPP)" value={lr.hpp} testid="lr-hpp" />
          <Row label="Laba Kotor" value={lr.laba_kotor} bold testid="lr-laba-kotor" />
          <p className="px-3.5 pt-3 text-[10px] uppercase tracking-[0.15em] font-bold text-muted-foreground">Beban Operasional</p>
          {lr.beban.length === 0 && <p className="px-3.5 py-2 text-sm text-muted-foreground">Tidak ada beban pada periode ini.</p>}
          {lr.beban.map((b, i) => <Row key={b.id || `${b.tanggal}-${i}`} label={`${b.keterangan} · ${tgl(b.tanggal)}`} value={b.jumlah} testid={`lr-beban-${i}`} />)}
          <Row label="Total Beban" value={lr.total_beban} testid="lr-total-beban" />
          <Row label="Laba Bersih" value={lr.laba_bersih} bold testid="lr-laba-bersih" />
        </div>
      )}
    </>
  );
}
